/*
 * @Author: 赵大壮 372839241@qq.com
 * @Date: 2025-08-24 21:27:23
 * @LastEditors: 赵大壮 372839241@qq.com
 * @LastEditTime: 2026-04-06 23:48:54
 * @FilePath: \利享乡村管理后台\src\utils\ImgUtil.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import ny_config from "@/api/nyConfig";
import api from "@/api/nyApiJson";

class ImgUtil{

    bindImage(id) {
        if (!id) {
            return "";
        }
        let apiName = "显示图片";
        let apiJson: ny_config = api[apiName];
        let url = apiJson.baseUrl + apiJson.url + "?image=" + id
        return url;
    }

    bindImages(ids) {
        if (!ids) {
            return [];
        }
        let apiJson: ny_config = api["显示图片"];
        let arr = ids.split(",")
        let res = []
        arr.forEach(id =>{
            let url = apiJson.baseUrl + apiJson.url + "?image=" + id
            res.push(url)
        })
        return res;
    }

    bindImageList(id) {
        if (!id) {
            return [];
        }
        let apiName = "显示图片";
        let apiJson: ny_config = api[apiName];
        let url = apiJson.baseUrl + apiJson.url + "?image=" + id
        let arr = []
        arr.push(url)
        return arr;
    }

    bindVideo(id) {
        if (!id) {
            return [];
        }
        let apiName = "显示视频";
        let apiJson: ny_config = api[apiName];
        let url = apiJson.baseUrl + apiJson.url + "/" + id
        let arr = []
        arr.push(url)
        return arr;
    }
}
export default ImgUtil
